import tokenManager from "@/shared/securityTokenManager.js";

export default class TokenUseCase {
  private readonly _tokenManager = tokenManager;

  async canChangeSchoolFinancialDetails() {
    const permissions = await tokenManager.getUserPermissionAsync();

    if (
      // @ts-ignore
      permissions.findIndex((item) => item.UserPermissionCd === "UP_ScBAU") > 0
    )
      return true;
    else return false;
  }

  async getAccessToken() {
    try {
      return await tokenManager.getAccessTokenAsync();
    } catch (error) {
      throw error;
    }
  }

  async setAccessToken(accessToken: string) {
    try {
      await tokenManager.setAccessTokenAsync(accessToken);
    } catch (error) {
      throw error;
    }
  }

  async clearAccessToken() {
    try {
      await tokenManager.setAccessTokenAsync("");
    } catch (error) {
      throw error;
    }
  }

  async doesAccessTokenExist() {
    try {
      return await tokenManager.doesAccessTokenExistAsync();
    } catch (error) {
      throw error;
    }
  }

  async getUserPermission() {
    try {
      const result = await tokenManager.getUserPermissionAsync();
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getTokenExpiryTime() {
    try {
      const timeInSeconds = await tokenManager.getTokenExpiryTime();

      if (timeInSeconds) {
        return Number(timeInSeconds);
      }
    } catch (error) {
      throw error;
    }
  }
}
